export function calculateTotalPages(
  totalItems: number,
  itemsPerPage: number
): number {
  if (itemsPerPage === 0) {
    return 0;
  }
  return Math.ceil(totalItems / itemsPerPage);
}